import { render, staticRenderFns } from "./GeneralRecipientList.vue?vue&type=template&id=6256386a&"
import script from "./GeneralRecipientList.vue?vue&type=script&lang=js&"
export * from "./GeneralRecipientList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports